export default __webpack_public_path__ + "static/sprite-84aa0efd920c4fa8c77596265717e6a1.svg";